export class Remark {
    company_remark_id ? = '';
    company_id ? = '';
    user_id ? = '';
    company_remark ? = '';
    company_remark_type ? = '';
    remark_style ? = '';
}


// WEBPACK FOOTER //
// ./src/app/type/remark.ts